// extracted by mini-css-extract-plugin
export default {"range":"Range_range__nkONW"};